import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AbilityService from 'ember-can/services/abilities';
import type AuthzService from 'garaje/services/authz';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';

// This controls what companies are allow to do with regards to
// external notifications. Primarily  to protect against spam / abuse
export default class ExternalNotificationAbility extends Ability {
  @service declare abilities: AbilityService;
  @service declare authz: AuthzService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;

  // Invite settings and Email management are managed by separate permissions.
  get canCustomizeAny(): boolean {
    const hasPermission = this.authz.hasPermissionAtCurrentLocation(
      Permission.VISITORS_LOCATION_CONFIG_UPDATE_VISITOR_NOTIFICATIONS,
    );
    const hasRole = this.abilities.can('visit advance-settings');

    if (!(hasPermission || hasRole)) return false;

    return this.canCustomizeEmail || this.canCustomizeSms;
  }

  get canCustomizeSms(): boolean {
    const allowTextMods = this.featureFlags.isEnabled('allow-host-notification-text-mods-during-trial', {
      // eslint-disable-next-line ember/use-ember-get-and-set
      createdAt: this.state.currentCompany.createdAt?.getTime() ?? 0,
    });

    if (allowTextMods) return true;
    return false;
  }

  get canCustomizeEmail(): boolean {
    const allowEmailMods = this.featureFlags.isEnabled('email-customization', {
      // eslint-disable-next-line ember/use-ember-get-and-set
      createdAt: this.state.currentCompany.createdAt?.getTime() ?? 0,
    });

    if (allowEmailMods) return true;
    return false;
  }
}
